import { createDateRangeFilter } from '@ayocore/platform/client/components/RepositoryTable/createDateRangeFilter';
import type { LeadRepository } from '@ayocore/erp/crm/server/repositories/LeadRepository';

export const FilterByCreatedDate = createDateRangeFilter<LeadRepository>(
  'created_date',
  'Создана с — по',
  (repo, from, to) => repo.filterByCreatedAtRange(from, to)
);
